import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Material Code Name Cell Renderer
 *
 * Displays material code and name for GroupedMaterialWithCustomers.
 * Reads directly from params.data.code and params.data.name.
 * Code is displayed in small gray monospace text, name in regular text.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'material',
 *   headerName: 'Material',
 *   cellRenderer: MaterialCodeNameCellRendererComponent,
 *   field: 'code',
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-material-code-name-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col text-sm whitespace-nowrap">
      <span class="table-text-code text-xs text-gray-500">
        {{ materialCode }}
      </span>
      <span>{{ materialName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .table-text-code {
      font-family: 'Courier New', monospace;
    }
  `]
})
export class MaterialCodeNameCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get materialCode(): string {
    return this.params.data?.code ?? '-';
  }

  get materialName(): string {
    return this.params.data?.name ?? '-';
  }
}
